import React from 'react';
import Util from 'util/util';
import { TFunction } from 'i18next';
import { Translation } from 'react-i18next';

import './SelectComponentStandards.scss';

export interface SelectOption {
  name: string;
  value: string;
}

interface Props {
  label: string;
  value: string;
  placeholder?: string;
  error?: string;
  className?: string;
  id?: string;
  selectOptions: SelectOption[];
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

export default function SelectComponentStandards({
  label,
  value,
  placeholder,
  error,
  className,
  id,
  selectOptions,
  disabled,
  onChange,
}: Props) {
  const computedId = id || 'edit-' + Util.removeSpaces(label);

  return (
    <Translation>
      {(t: TFunction) => (
        <div className={`selectComponent mb-2 ${className ?? ''}`}>
          <div className="form-group w-100">
            <label htmlFor={computedId} className={error ? 'text-danger' : ''}>
              <b>{label}</b>
            </label>

            <select
              id={computedId}
              name={computedId}
              className={`form-control w-100 pl-3 pr-3 ${error ? 'is-invalid' : ''}`}
              onChange={onChange}
              placeholder={placeholder}
              value={value}
              disabled={disabled}
            >
              {selectOptions?.map((option, i) => (
                <option key={i} className="text-capitalize" value={option.value}>
                  {t(option.name)}
                </option>
              ))}
            </select>

            <div className={error ? '' : 'd-none'}>
              <small className="text-danger">{error}</small>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}
